var map = {
	"./alert.svg": 63718,
	"./bee-settings.svg": 12823,
	"./book.svg": 81446,
	"./calibrate.svg": 44144,
	"./cube.svg": 55757,
	"./file-document-check.svg": 89424,
	"./help-box-multiple-outline.svg": 41617,
	"./logout.svg": 61545,
	"./menu-close.svg": 68314,
	"./quote.svg": 35124,
	"./telegram.svg": 56437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92498;